import { Controller } from "remult";

@Controller("sub-category-image-methods")
export class SubCategoryImageMethods {}

